const COLORS = { Steven: "#1D4ED8", Richard: "#0EA5A4" };

export const FounderAvatar = ({ name, size = 28 }) => {
  const label = name === "Both founders" ? "SR" : (name || "?").slice(0, 1).toUpperCase();
  const bg = COLORS[name] || "#7C3AED";
  return (
    <span
      className="inline-flex shrink-0 items-center justify-center rounded-full font-bold text-white"
      style={{ backgroundColor: bg, width: size, height: size, fontSize: size * 0.42 }}
      title={name}
    >
      {label}
    </span>
  );
};
